import { createFileRoute } from "@tanstack/react-router";

import { Dashboard } from "/src/routes/orgAdmin/dashboard";

export const Route = createFileRoute("/_main/dashboard")({
  component: Dashboard,
});
